import React from "react";
import PropTypes from "prop-types";
import selectn from "selectn";

import CardWrapper from "cards/components/CardWrapper";
import SummaryCardLayout from "cards/components/SummaryCardLayout";
import SummaryHeadline from "cards/components/SummaryHeadline";
import StoryDescription from "cards/components/StoryDescription";
import BylineWrapper from "cards/components/BylineWrapper";
import ResponsiveImage from "components/Library/ResponsiveImage";

import { IMAGE_ASPECT_RATIO } from "config/constants";
import styles from "./SummaryCard.css";
import SUMMARY_CARD_FRAGMENT from "./SummaryCard.graphql";

export default class SummaryCard extends React.Component {
  static fragments = { content: SUMMARY_CARD_FRAGMENT };

  render() {
    const { story } = this.props;
    const primaryImage = story.primary_image;
    const imageUrl = selectn("crops.square.url", primaryImage);

    return (
      <CardWrapper className={styles.root}>
        <SummaryCardLayout
          image={
            imageUrl && (
              <ResponsiveImage
                src={imageUrl}
                lazyload={true}
                aspectRatio={IMAGE_ASPECT_RATIO.SQUARE}
              />
            )
          }
        >
          <BylineWrapper
            story={story}
            className={styles.bylineHeader}
            showSaveTag={this.props.showSaveTag}
          />
          <SummaryHeadline
            headline={story.headline}
            permalink={story.permalink}
          />
          <StoryDescription description={story.og_description} />
        </SummaryCardLayout>
      </CardWrapper>
    );
  }
}

SummaryCard.propTypes = {
  story: PropTypes.object.isRequired,
};
